export default __webpack_public_path__ + "static/media/Banner_bg.9954dbd2.png";